var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g2, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Image(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1802,
    height: 628,
    viewBox: "0 0 1802 628",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1255.37 578.09C1554 578.09 1659.05 564.99 1659.05 548.83C1659.05 532.67 1438 519.57 1255.37 519.57C800.464 519.57 431.69 532.67 431.69 548.83C431.69 564.99 800.464 578.09 1255.37 578.09Z",
    fill: "#CFCFE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1114.95 335.21C1114.95 575.49 980.26 554.85 814.12 554.85C647.98 554.85 513.29 566.81 513.29 335.21C513.29 169.06 647.98 74.7197 814.12 74.7197C980.26 74.7197 1114.95 169.06 1114.95 335.21Z",
    fill: "#1A272E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M832.05 97.63C832.05 97.63 581.77 74.71 562.35 379.07C562.35 379.07 542.78 560.39 814.12 554.84C814.12 554.84 1045.95 563.71 1057.32 413.22C1067.86 273.87 1056.41 112.4 832.05 97.63Z",
    fill: "#8D8DB1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M969.407 472.582C1055.18 386.808 1055.18 247.741 969.407 161.967C883.633 76.193 744.566 76.193 658.792 161.967C573.018 247.741 573.018 386.808 658.792 472.582C744.566 558.356 883.633 558.356 969.407 472.582Z",
    fill: "#8D8DB1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M957.139 460.314C1036.14 381.315 1036.14 253.234 957.139 174.235C878.141 95.2367 750.059 95.2367 671.061 174.235C592.062 253.234 592.062 381.315 671.061 460.314C750.059 539.312 878.141 539.312 957.139 460.314Z",
    fill: "#BDBDD8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M813.87 143.47H849.94C855.3 143.47 859 148.86 857.06 153.86L837.47 204.51L821 247.13C818.48 253.64 809.27 253.64 806.76 247.13L790.28 204.51L770.69 153.86C768.75 148.86 772.45 143.47 777.81 143.47H813.87Z",
    fill: "#1A272E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M813.87 489.55H777.8C772.44 489.55 768.74 484.16 770.68 479.16L790.27 428.51L806.75 385.89C809.27 379.38 818.48 379.38 820.99 385.89L837.47 428.51L857.06 479.16C859 484.16 855.3 489.55 849.94 489.55H813.87Z",
    fill: "#1A272E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M936.23 194.15L961.74 219.66C965.53 223.45 964.34 229.87 959.43 232.04L909.76 254L867.96 272.48C861.58 275.3 855.07 268.79 857.89 262.41L876.37 220.61L898.33 170.94C900.5 166.03 906.92 164.84 910.71 168.63L936.23 194.15Z",
    fill: "#1A272E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M691.52 438.86L666.01 413.35C662.22 409.56 663.41 403.14 668.32 400.97L717.99 379.01L759.79 360.53C766.17 357.71 772.68 364.22 769.86 370.6L751.38 412.4L729.42 462.07C727.25 466.98 720.83 468.17 717.04 464.38L691.52 438.86Z",
    fill: "#1A272E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M986.91 316.51V352.58C986.91 357.94 981.52 361.64 976.52 359.7L925.87 340.11L883.25 323.63C876.74 321.11 876.74 311.9 883.25 309.39L925.87 292.91L976.52 273.32C981.52 271.38 986.91 275.08 986.91 280.44V316.51Z",
    fill: "#1A272E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M640.83 316.51V280.44C640.83 275.08 646.22 271.38 651.22 273.32L701.87 292.91L744.49 309.39C751 311.91 751 321.12 744.49 323.63L701.87 340.11L651.22 359.7C646.22 361.64 640.83 357.94 640.83 352.58V316.51Z",
    fill: "#1A272E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M936.23 438.86L910.72 464.37C906.93 468.16 900.51 466.97 898.34 462.06L876.38 412.39L857.9 370.59C855.08 364.21 861.59 357.7 867.97 360.52L909.77 379L959.44 400.96C964.35 403.13 965.54 409.55 961.75 413.34L936.23 438.86Z",
    fill: "#1A272E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M691.52 194.15L717.03 168.64C720.82 164.85 727.24 166.04 729.41 170.95L751.37 220.62L769.85 262.42C772.67 268.8 766.16 275.31 759.78 272.49L717.98 254.01L668.31 232.05C663.4 229.88 662.21 223.46 666 219.67L691.52 194.15Z",
    fill: "#1A272E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M856.374 327.364C861.882 304.037 847.438 280.662 824.111 275.154C800.784 269.646 777.409 284.091 771.901 307.417C766.392 330.744 780.837 354.12 804.164 359.628C827.491 365.136 850.866 350.691 856.374 327.364Z",
    fill: "#1A272E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M814.12 335.21C824.022 335.21 832.05 327.182 832.05 317.28C832.05 307.377 824.022 299.35 814.12 299.35C804.218 299.35 796.19 307.377 796.19 317.28C796.19 327.182 804.218 335.21 814.12 335.21Z",
    fill: "#0072BC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M647.96 136.7C647.96 136.7 520.75 235.15 543.84 371.9C543.84 371.89 494.57 232.45 647.96 136.7Z",
    fill: "#8D8DB1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M1041.68 187.05C1041.68 187.05 1088.84 264.83 1085.53 400.53C1085.53 400.52 1108.7 258.2 1041.68 187.05Z",
    fill: "#8D8DB1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1400.31 442.53H1164.83V323.78L1408.38 0.459961H1525.13V321.4H1605.81V442.54H1525.13V555.3H1400.31V442.53ZM1400.31 196.36L1308.3 321.4H1400.32V196.36H1400.31Z",
    fill: "#0072BC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M235.98 442.53H0.48999L17.04 323.78L260.59 0.459961H360.79V321.4H441.47V442.54H360.79V555.3H235.98V442.53ZM235.98 196.36L143.96 321.4H235.98V196.36Z",
    fill: "#0072BC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1731.93 100.16H1717.88V240.77H1731.93V100.16Z",
    fill: "#BDBDD8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1798.4 87.3799H1649.37V100.16H1798.4V87.3799Z",
    fill: "#1A272E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1652.71 103.71H1649.48C1648.41 103.71 1647.55 102.84 1647.55 101.78V85.7601C1647.55 84.6901 1648.42 83.8301 1649.48 83.8301H1652.71C1653.78 83.8301 1654.64 84.7001 1654.64 85.7601V101.78C1654.65 102.85 1653.78 103.71 1652.71 103.71Z",
    fill: "#1A272E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1800.01 103.71H1796.78C1795.71 103.71 1794.85 102.84 1794.85 101.78V85.7601C1794.85 84.6901 1795.72 83.8301 1796.78 83.8301H1800.01C1801.08 83.8301 1801.94 84.7001 1801.94 85.7601V101.78C1801.95 102.85 1801.08 103.71 1800.01 103.71Z",
    fill: "#1A272E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1741.21 85.1401H1708.09V102.41H1741.21V85.1401Z",
    fill: "#BDBDD8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M1717.88 102.41H1731.93L1717.88 110.23V102.41Z",
    fill: "#1A272E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1754.99 528.69H1694.82V241.31C1694.82 229.77 1704.17 220.42 1715.71 220.42H1734.1C1745.64 220.42 1754.99 229.77 1754.99 241.31V528.69V528.69Z",
    fill: "#EA4230"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_618_92",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1694,
    y: 220,
    width: 61,
    height: 309
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1754.99 528.69H1694.82V241.31C1694.82 229.77 1704.17 220.42 1715.71 220.42H1734.1C1745.64 220.42 1754.99 229.77 1754.99 241.31V528.69V528.69Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_618_92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1766.05 211.521H1724.65V540.301H1766.05V211.521Z",
    fill: "#C1271B"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1776.79 553.231H1674.15C1674.15 538.951 1685.73 527.371 1700.01 527.371H1750.92C1765.21 527.371 1776.79 538.951 1776.79 553.231Z",
    fill: "#1A272E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1782.3 558.97H1668.36C1667.32 558.97 1666.48 558.13 1666.48 557.09V553.62C1666.48 552.58 1667.32 551.74 1668.36 551.74H1782.3C1783.34 551.74 1784.18 552.58 1784.18 553.62V557.09C1784.18 558.12 1783.33 558.97 1782.3 558.97Z",
    fill: "#1A272E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1739.07 223.86H1710.73C1708.07 223.86 1705.91 221.7 1705.91 219.04V216.35C1705.91 213.69 1708.07 211.53 1710.73 211.53H1739.07C1741.73 211.53 1743.89 213.69 1743.89 216.35V219.04C1743.9 221.7 1741.74 223.86 1739.07 223.86Z",
    fill: "#1A272E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M1709.26 391.11C1705.96 391.11 1703.28 388.43 1703.28 385.13V344.45C1703.28 341.15 1705.96 338.47 1709.26 338.47C1712.56 338.47 1715.24 341.15 1715.24 344.45V385.13C1715.24 388.43 1712.56 391.11 1709.26 391.11Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M1709.26 410.65C1705.96 410.65 1703.28 407.97 1703.28 404.67V400.51C1703.28 397.21 1705.96 394.53 1709.26 394.53C1712.56 394.53 1715.24 397.21 1715.24 400.51V404.67C1715.24 407.97 1712.56 410.65 1709.26 410.65Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1775.29 294.652C1779.8 266.849 1760.92 240.652 1733.12 236.14C1705.32 231.628 1679.12 250.509 1674.61 278.312C1670.1 306.115 1688.98 332.312 1716.78 336.824C1744.58 341.336 1770.78 322.455 1775.29 294.652Z",
    fill: "#1A272E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1742.08 327.794C1764.9 318.342 1775.73 292.181 1766.28 269.362C1756.83 246.544 1730.67 235.708 1707.85 245.16C1685.03 254.612 1674.2 280.773 1683.65 303.591C1693.1 326.41 1719.26 337.246 1742.08 327.794Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_618_92",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1680,
    y: 241,
    width: 90,
    height: 91
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1742.08 327.794C1764.9 318.342 1775.73 292.181 1766.28 269.362C1756.83 246.544 1730.67 235.708 1707.85 245.16C1685.03 254.612 1674.2 280.773 1683.65 303.591C1693.1 326.41 1719.26 337.246 1742.08 327.794Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_618_92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1752.35 247.68C1752.35 247.68 1753.99 307.84 1698.3 325.93C1698.3 325.93 1738.26 351.56 1769.61 317.21C1800.97 282.86 1752.35 247.68 1752.35 247.68Z",
    fill: "#BDBDD8"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1725.33 293.54C1729.22 293.54 1732.37 290.388 1732.37 286.5C1732.37 282.612 1729.22 279.46 1725.33 279.46C1721.44 279.46 1718.29 282.612 1718.29 286.5C1718.29 290.388 1721.44 293.54 1725.33 293.54Z",
    fill: "#1A272E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1726.59 247.68H1724.06V259.78H1726.59V247.68Z",
    fill: "#1A272E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1726.59 313.83H1724.06V325.93H1726.59V313.83Z",
    fill: "#1A272E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1764.45 288.07V285.54H1752.35V288.07H1764.45Z",
    fill: "#1A272E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1698.3 288.064V285.534H1686.2V288.064H1698.3Z",
    fill: "#1A272E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1753.87 260.012L1752.09 258.223L1743.53 266.779L1745.32 268.568L1753.87 260.012Z",
    fill: "#1A272E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1707.1 306.782L1705.31 304.993L1696.76 313.549L1698.55 315.338L1707.1 306.782Z",
    fill: "#1A272E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1752.13 315.357L1753.92 313.568L1745.36 305.012L1743.57 306.801L1752.13 315.357Z",
    fill: "#1A272E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1705.34 268.572L1707.13 266.783L1698.58 258.227L1696.79 260.016L1705.34 268.572Z",
    fill: "#1A272E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1741.65 270.48L1726.39 282.48L1725.33 286.8L1729.66 285.74L1741.65 270.48Z",
    fill: "#F1BF46"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M823.83 500.13H804.4V519.56H823.83V500.13Z",
    fill: "#1A272E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1420.69 529.6C1381.25 529.6 1343.99 518.67 1306.79 496.19C1273.88 476.31 1245.09 450.41 1214.6 422.99C1155.72 370.03 1094.84 315.27 1003.02 308.77C953.38 305.25 912.77 317.72 882.31 345.84C822.48 401.06 820.88 499.21 820.87 500.19L807.38 500.07C807.39 499 807.69 473.59 815.84 440.64C823.41 410.04 839.48 367.04 873.11 335.98C906.42 305.2 950.45 291.52 1003.99 295.31C1100.43 302.14 1163.07 358.48 1223.64 412.96C1282.62 466.01 1338.32 516.11 1420.71 516.11C1516.46 516.11 1559.48 496.51 1594.04 480.75C1620.59 468.65 1643.52 458.2 1680.83 461.12L1679.78 474.57C1645.93 471.92 1625.51 481.23 1599.64 493.03C1563.87 509.33 1519.37 529.6 1420.69 529.6Z",
    fill: "#EA4230"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1694.59 453.55H1666V482.14H1694.59V453.55Z",
    fill: "#1A272E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Image);
export default __webpack_public_path__ + "static/media/404-image.83703fc885b5f6d20c9b71b4aa742c0d.svg";
export { ForwardRef as ReactComponent };